import { render, staticRenderFns } from "./CourseTopicDetailPopup.vue?vue&type=template&id=7e4a701e&scoped=true"
import script from "./CourseTopicDetailPopup.vue?vue&type=script&lang=js"
export * from "./CourseTopicDetailPopup.vue?vue&type=script&lang=js"
import style0 from "./CourseTopicDetailPopup.vue?vue&type=style&index=0&id=7e4a701e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4a701e",
  null
  
)

export default component.exports